import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface FetchMasterySeriesParams {
  user_id: string | number;
  currency?: string;
}

export default function useFetchActiveMasterySeries(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<any, Error, FetchMasterySeriesParams>(
    async ({user_id, currency = 'INR'}) => {
      const response = await ChessRestClient.get(
        `subscription/v1/mastery-series/active/?currency=${currency}&user_id=${user_id}`,
      );
      return response;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return {
    ...mutation,
  };
}
